import { isElementType } from '@lumapps/wrex/slate/utils/isElementType';

import { Iframe } from '../components/blocks/Iframe';

export const isIframeElement = isElementType(Iframe);
